import { withChartLayout } from 'components/common';
import IVs from 'components/features/chart/ivs/IVs';

const IVsPage = withChartLayout('IVs')(IVs);
export default IVsPage;
